// ═══════════════════════════════════════════════════════════════════════════════
// MICROSOFT GRAPH — /me (user profile)
// ═══════════════════════════════════════════════════════════════════════════════
// Fetches the signed-in user's profile from Entra ID so LOI signatures can
// include their real name, email, phone, and title — matching whatever they
// have set in Microsoft 365 rather than hardcoded app settings.

const GRAPH_ME = "https://graph.microsoft.com/v1.0/me?$select=displayName,givenName,surname,mail,userPrincipalName,mobilePhone,businessPhones,jobTitle";

const profileRequest = { scopes: ["User.Read"] };

async function getGraphToken(msalInstance) {
  const account = msalInstance.getActiveAccount() || msalInstance.getAllAccounts()[0];
  if (!account) throw new Error("No signed-in account.");
  // Profile is non-critical — if silent token acquire fails, just throw and
  // let UserProfileContext fall back to MSAL account claims (no popup, no
  // forced redirect for a profile fetch).
  const result = await msalInstance.acquireTokenSilent({ ...profileRequest, account });
  return result.accessToken;
}

/**
 * Fetch the signed-in user's profile from Graph.
 * @returns {Promise<{ displayName: string, email: string, phone: string, jobTitle: string, mobilePhone: string|null, businessPhones: string[] }>}
 */
export async function fetchMe(msalInstance) {
  const token = await getGraphToken(msalInstance);
  const res = await fetch(GRAPH_ME, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) {
    let detail = "";
    try { detail = (await res.json())?.error?.message || ""; } catch {}
    throw new Error(`Graph /me failed (${res.status}): ${detail}`);
  }
  const me = await res.json();
  // Prefer mobile, fall back to the first business phone.
  const phone = me.mobilePhone || me.businessPhones?.[0] || "";
  return {
    displayName: me.displayName || "",
    email: me.mail || me.userPrincipalName || "",
    phone,
    jobTitle: me.jobTitle || "",
    mobilePhone: me.mobilePhone || null,
    businessPhones: me.businessPhones || [],
  };
}
